// 设置token
export const SET_TOKEN = 'SET_TOKEN';
